<template>
  <div class="notice_bar" @click="clickHandle">
    <img class="left" src="@/assets/img/notic_icon.png" alt="">
    <div ref="notice_swipe" class="notice-swipe">
      <div
        v-if="isScroll"
        ref="swipe_scroll"
        class="notice-swipe_scroll"
      >
        {{ noticeInfo + "\xa0\xa0\xa0\xa0" + noticeInfo }}
      </div>
      <div v-else ref="swipe_scroll" class="notice-swipe_scroll">
        {{ noticeInfo }}
      </div>
    </div>
    <img class="right" src="@/assets/img/icon_left.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'NoticeBar',
  props: {
    noticeInfo: {
      type: String,
      default: '这是一条没用的通知。。。。。。。。。。。。。。。。。。。。。。。。。。'
    }
  },
  data() {
    return {
      isScroll: false
    }
  },
  computed: {
  },
  mounted() {
    const swipeEl = this.$refs['notice_swipe']
    const el = this.$refs['swipe_scroll']
    console.log(swipeEl.clientWidth, el.scrollWidth)
    if (el && swipeEl) {
      const step = el.scrollWidth + swipeEl.clientWidth + 104 || 0
      if (!step || swipeEl.clientWidth > el.scrollWidth) return
      console.log(step)
      this.isScroll = true
      const cusKeyframes = `@keyframes scrollnotice {
                            0%{
                              left: 0px
                            }
                            100%{
                              left: -${(step / 2).toFixed(0)}px
                            }
                          }`
      const style = document.createElement('style')
      // 设置style属性
      style.type = 'text/css'
      // 将 keyframes样式写入style内
      style.innerHTML = cusKeyframes
      // 将style样式存放到head标签
      document.getElementsByTagName('head')[0].appendChild(style)
      setTimeout(() => {
        el.style.animation = `scrollnotice ${(step / 90).toFixed(
          0
        )}s linear infinite normal`
      }, 1500)
    }
  },
  methods: {
    clickHandle() {
      this.$emit('notice-click', this.noticeInfo)
    }
  }
}
</script>

<style scoped lang="less">
.notice_bar {
  display: flex;
  align-items: center;
  height: 40px;
  box-sizing: border-box;
  background: #ffffff;
  border: 0.5px solid #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  font-family: PingFangSC-Medium;
  font-size: 13px;
  color: #333333;
  line-height: 40px;
  padding: 0 12px;
  overflow: hidden;
  .left {
    width: 18px;
    margin-right: 6.5px;
    flex-shrink: 0;
  }
  .right{
    width: 14px;
  }
  .notice-swipe {
    flex: 1;
    word-break: keep-all;
    overflow: scroll;
    position: relative;
  }
  .notice-swipe_scroll {
    display: inline-block;
    white-space: nowrap;
    position: relative;
  }
  .notice-swipe::-webkit-scrollbar {
    display: none;
  }
  .icon-box {
    margin-left: 20px;
    width: 14px;
    height: 14px;
  }
}
</style>
